import { createNamespacedHelpers } from 'vuex';
import { defaultState as state, mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

// TODO: replace with composables (1 day)
const emergingThreatsStore = {
  namespaced: true,
  actions,
  state,
  mutations,
  getters,
};

export const { mapActions } = createNamespacedHelpers('emergingThreats');

export default emergingThreatsStore;
